import sortExtrasByPriority from 'utils/extras/methods/sortExtrasByPriority';
import notIncludedInBase from 'utils/extras/methods/notIncludedInBase';

export default {
  sortExtrasByPriority,
  notIncludedInBase,
};
